export function DrawCirclePoints(
  word,
  radius,
  center
) {
  let pts = word.length;

  let slice = (2 * Math.PI) / pts;

  let points = [];
  let letters = [];

  for (let i = 0; i < pts; i++) {
    let angle = slice * i;

    let x =
      center.x + radius * Math.cos(angle);

    let y =
      center.y + radius * Math.sin(angle);

    points.push([{ x, y }]);

    letters.push({
      id: crypto.randomUUID(),
      char: word[i].toUpperCase(),
      x,
      y,
    });
  }

  return { points, letters };
}